import { useMutation, useQueryClient } from "@tanstack/react-query";

import { updatePatientZoomMeetingSessionType } from "~/providers/api/patientZoomMeetingsService";
import { UpdatePatientZoomMeetingSessionTypeRequest } from "~/providers/utils/types/zoomMeetingTypes";

export const useUpdatePatientZoomMeetingSessionType = (patientId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (
      request: Omit<UpdatePatientZoomMeetingSessionTypeRequest, "patientId">,
    ) =>
      updatePatientZoomMeetingSessionType({
        patientId,
        ...request,
      }),
    onSuccess: async (_data, variables) => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: ["getPatientZoomMeetings", patientId],
        }),
        queryClient.invalidateQueries({
          queryKey: ["getPatientZoomMeeting", patientId, variables.sessionId],
        }),
        queryClient.invalidateQueries({
          queryKey: [
            "getPatientZoomMeetingSoapNote",
            patientId,
            variables.sessionId,
          ],
        }),
      ]);
    },
  });
};
